<dojo-solver [solver]="solver()" />
